/* unplugin-vue-components disabled */import { render } from "./source-type.vue?vue&type=template&id=3225d175"
import script from "./source-type.vue?vue&type=script&lang=js"
export * from "./source-type.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/sources/source-type.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3225d175"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3225d175', __exports__)) {
    api.reload('3225d175', __exports__)
  }
  
  module.hot.accept("./source-type.vue?vue&type=template&id=3225d175", () => {
    api.rerender('3225d175', render)
  })

}


export default __exports__